module.exports = __webpack_public_path__ + "assets/images/peaceful-autumn-afternoon.webp";